<template>
  <div class="navBar">
    <nav class="container">
      <ul class="navList">
        <li :class="$route.path.includes('/home') ? 'on' : '' " class="navItem"><router-link to="/">首页</router-link></li>
        <li class="navItem place" :class="$route.path.includes('/courier') ? 'on' : '' "  @mouseenter="mouseOver" @mouseleave="mouseLeave">
          <router-link :to="{name:'CityExpress'}">我要下单 <img src="../assets/images/home/selected.png" alt=""></router-link>
          <ul class="hoverList">
            <li class="hoverItem" v-for="(item, index) in list" :key="index" @click="changeTab(item.url)"><span>{{item.name}}</span></li>
          </ul>
        </li>
        <li class="navItem" :class="$route.path.includes('/person') ? 'on' : '' "><router-link :to="{name:'Datum'}">个人中心</router-link></li>
        <li class="navItem" :class="$route.path.includes('/price') ? 'on' : '' "><router-link :to="{name: 'Price'}">服务价格</router-link></li>
        <li class="navItem" :class="$route.path.includes('/download') ? 'on' : '' "><router-link :to="{name:'Download'}">下载中心</router-link></li>
        <li class="navItem" :class="$route.path.includes('/about') ? 'on' : '' "><router-link :to="{name:'About'}">联系我们</router-link></li>
      </ul>
    </nav>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        list: [
          {
            name:'快递服务',
            url: '/courier/cityExpress'
          },
          {
            name:'医疗服务',
            url: '/courier/medical'
          },
          {
            name:'票务服务',
            url: '/courier/ticket'
          },
          {
            name:'其他服务',
            url: '/courier/other'
          }
        ]
      }
    },
    methods: {
      // 移入
      mouseOver() {
        document.getElementsByClassName('hoverList')[0].style.display = 'block'
      },
      // 移出
      mouseLeave() {
        document.getElementsByClassName('hoverList')[0].style.display = 'none'
      },
      changeTab(url) {
        this.$router.push(url)
        document.getElementsByClassName('hoverList')[0].style.display = 'none'
      }
    }
  }
</script>

<style scoped lang="less" type="text/less">
  .navBar{
    background: #000;
    height: 60px;
    .navList{
      display: flex;
      color:#fff;
      .navItem{
        margin-right: 21px;
        padding:21px 36px;
        font-size: 18px;
        &.on{
          background: #E60012;
        }
        &.place{
          position: relative;
          .hoverList{
            display: none;
            position: absolute;
            top: 60px;
            left: 0;
            width: 100%;
            background: #fff;
            box-shadow:0px 3px 21px 0px rgba(0, 0, 0, 0.25);
            z-index: 999;
            .hoverItem{
              margin:10px 0;
              line-height: 30px;
              cursor: pointer;
              span{
                color:#333;
                font-size: 16px;
                font-weight: bold;
              }
              &:before{
                content: '';
                display: inline-block;
                width: 5px;
                height: 5px;
                background: #c6c6c6;
                border-radius:50%;
                margin:0px 15px 3px 34px;
              }
            }
          }
        }
        a{
          color:#fff;
          img{
            width: 10px;
            height: 6px;
            vertical-align: middle;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue